import { Component, OnInit, Renderer2 } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
  ComponentName,
  ModuleName,
  Modules,
  NotificationTextMessage,
} from '@app/core/Enum';
import { Notes } from '@app/core/Enum/note';
import {
  GetNoteParamModel,
  GlobalComponent,
  NoteDataModel,
} from '@app/core/Models';
import { CommonService, ModulePermission } from '@app/core/Services';
import {
  ConvertToHtml,
  GetAllContactsBasedonType,
  GetAllDislcosuresListBasedonType,
  GetExaminersForReport,
  GetNotesData,
  GetTrusteesDataById,
  GetTrusteesDataByPeriodId,
  GetTrusteesDisclosuresBasedOnPeriodId,
  MenuState,
  SaveExaminersReportData,
  SaveNoteData,
  SaveTrusteeDisclosures,
  ToggleCheck,
  ToggleCheckTrustee,
} from '@app/core/Store';
import { AddClosePopupComponent, EditAuditReportPopupComponent } from '@app/modules/common';
import { Select, Store } from '@ngxs/store';
import {
  HtmlEditorService,
  ImageService,
  LinkService,
  PasteCleanupService,
  TableService,
  ToolbarService,
} from '@syncfusion/ej2-angular-richtexteditor';
import { Guid } from 'guid-typescript';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-trustees-report',
  templateUrl: './trustees-report.component.html',
  styleUrls: ['./trustees-report.component.scss'],
  providers: [
    ToolbarService,
    LinkService,
    ImageService,
    HtmlEditorService,
    TableService,
    PasteCleanupService,
  ],
})
export class TrusteesReportComponent implements OnInit {
  periodicDateList: any;
  jsonObject: any;

  @Select(MenuState.getSelectedMenuPermission)
  isViewPermission$: Observable<any>;
  commonNotificationText = NotificationTextMessage;

  accountingPeriod: Guid;

  noteData: NoteDataModel;
  notesModuleId: Notes;
  ids: Array<any>;
  trusteesReportForm: FormGroup;

  notesId = Guid.EMPTY as unknown as Guid;
  moduleId: number;
  headerText: string;
  isTrusteeReport: boolean = true;
  examiners: any[];

  public syncfusionRichTextEditorPasteCleanupSettings: object = {
    listConversion: true,
    prompt: false,
    plainText: true,
    keepFormat: true,
    deniedTags: ['a', 'img'],
    deniedAttrs: ['title', 'id', 'lang'],
  };
  
  trusteeReports: any[];
  isAudicted:boolean = false;
  trusteeReportDetails: any;
  charityType:number;
  periodicDate: any;
  minInvoiceDate: Date;
  maxInvoiceDate: Date = new Date();
  constructor(
    private store: Store,
    public dialog: MatDialog,
    private renderer: Renderer2,
    private globalComponent: GlobalComponent,
    private spinner: NgxSpinnerService,
    public commonService: CommonService,
    private modulePermission: ModulePermission,
    private router: Router,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.periodicDate = this.globalComponent.getFinancialPeriod();
    this.setForm();
    this.modulePermission.permissionData.subscribe((value) => {
      this.moduleId = value.data.id;
      this.isTrusteeReport = this.moduleId === Modules.TrusteesReport;
      if (
        value.data.url === this.router.url.slice(1) &&
        value.componentName === ComponentName.TrusteesReport
      ) {
        this.notesModuleId =
          this.moduleId === Modules.TrusteesReport
            ? Notes.Note44
            : this.moduleId === Modules.IndependentExaminerReport
            ? Notes.Note45
            : Notes.Note46;

        this.getHeaderText();
        this.setPeriodDate();
        if(!this.isTrusteeReport) this.getExaminersForReport();
         if(this.isTrusteeReport) this.getContactDetails();
      }
    });
    this.setInvoiceDateLimits();
  }

  getHeaderText(): void {
    this.headerText =
      this.moduleId === Modules.TrusteesReport
        ? ModuleName.TrusteesReport
        : this.moduleId === Modules.IndependentExaminerReport
        ? ModuleName.IndependentExaminerReport
        : ModuleName.AuditReport;
  }

  onCloseClick(): void {
    this.dialog.open(AddClosePopupComponent, {});
  }

  setPeriodDate(): void {
    this.periodicDateList = this.globalComponent.getFinancialPeriod();
    const defaultPeriodName = localStorage.getItem('defaultFinancialPeriod');
    if (defaultPeriodName) {
      const foundPeriod = this.periodicDateList.find(
        (p) => p.name.trim() === defaultPeriodName.trim()
      );
      if (foundPeriod) {
        this.trusteesReportForm.controls.accountingPeriod.setValue(foundPeriod.id);
      } else {
        this.trusteesReportForm.controls.accountingPeriod.setValue(
          this.periodicDateList[0].id
        );
      }
    } else {
      this.trusteesReportForm.controls.accountingPeriod.setValue(
        this.periodicDateList[0].id
      );
    }

    this.editNotes();
  }

  getExaminersForReport(): void {
    this.store.dispatch(new GetExaminersForReport()).subscribe((res) => {
      this.examiners = res.note?.examiners;
      const selectedExaminer = this.examiners.find(item => item?.isShowonreport === true);
      if (selectedExaminer) {
        this.trusteesReportForm.controls.name.setValue(selectedExaminer.id);
        this.trusteesReportForm.controls.date.setValue(selectedExaminer.dateReported);
      }
    });
  }
  

  editNotes(): void {
    this.spinner.show();

    const param: GetNoteParamModel = {
      id: this.notesModuleId,
      accountingPeriodId:
        this.trusteesReportForm.controls.accountingPeriod.value,
      ids: this.ids ?? null,
    };

    this.store.dispatch(new GetNotesData(param)).subscribe((res) => {
      this.notesId =
        res.note.noteData.userInputData !== null &&
        res.note.noteData.userInputData !== undefined
          ? res.note.noteData.userInputData.id
          : (Guid.EMPTY as unknown as Guid);

      this.trusteesReportForm.patchValue({
        textbox1: res.note.noteData.userInputData.data.textbox1
          ? res.note.noteData.userInputData.data.textbox1
          : '',
      });
    });
  }

  setForm(): void {
    this.trusteesReportForm = new FormGroup({
      accountingPeriod: new FormControl(''),
      name: new FormControl(''),
      date: new FormControl(''),
      textbox1: new FormControl(''),
    });
  }

  onAccountPeriodChange(): void {
    this.spinner.show();
    const selectedPeriodId = this.trusteesReportForm.controls.accountingPeriod.value;
    const selectedPeriod = this.periodicDateList.find(p => p.id === selectedPeriodId);
    if (selectedPeriod) {
      localStorage.setItem('defaultFinancialPeriod', selectedPeriod.name.trim());
    }
    //this.editNotes();
  }

  dataSubmit(): boolean {
    try {
      const arrayObj: any = {
        textbox1: this.commonService.sanitizeHtml(
          this.trusteesReportForm.controls.textbox1.value
        ),
      };
      this.jsonObject = <JSON>arrayObj;

      this.noteData = {
        accountingPeriodId:
          this.trusteesReportForm.controls.accountingPeriod.value,
        noteId: this.notesModuleId,
        checkBoxData: {},
        percentageData: null as any,
        data: this.jsonObject,
        id: this.notesId,
      };
    } catch (error) {
      this.spinner.hide();
      this.commonService.onFailure(NotificationTextMessage.errorMessage);
      return false;
    }
    return true;
  }

  onSave(): void {
    if (this.trusteesReportForm.invalid) {
      this.commonService.addValidation(this.trusteesReportForm, this.renderer);
    }
    else (this.dataSubmit()) 
    {
      this.store
        .dispatch(new SaveNoteData(this.noteData))
        .pipe()
        .subscribe(
          (res) => {
            if (res !== undefined) {
              this.notesId = res.note.noteId;
              this.commonService.onSucess(
                NotificationTextMessage.successMessage
              );
              if(!this.isTrusteeReport) this.saveExaminersReportData();
            } else {
              this.commonService.onFailure(
                NotificationTextMessage.errorMessage
              );
            }
          },
          (err) => {
            this.commonService.onFailure(err.error.Message);
          }
        );
      }
  }

  saveExaminersReportData(): void{
    const date = moment(this.trusteesReportForm.controls.date.value).format('YYYY-MM-DD');
    
    this.store.dispatch(new SaveExaminersReportData(this.trusteesReportForm.controls.name.value, date)).pipe()
      .subscribe(
        (res) => {
          if (res.noteData.isSuccess) {
            this.commonService.onSucess(NotificationTextMessage.successMessage);
          } else {
            this.commonService.onFailure(NotificationTextMessage.errorMessage);
          }
        },
        (err) => {
          this.commonService.onFailure(err.error.Message);
        }
      );
  }

  onCancel(): void {
    this.ngOnInit();
  }

  getAllDislcosuresListBasedonType(): void{
    
      this.store.dispatch(new GetTrusteesDisclosuresBasedOnPeriodId(this.trusteesReportForm.get('accountingPeriod')?.value,this.isAudicted)).pipe().subscribe(
        (response: any) => {
          this.trusteeReports = response?.common?.trusteeData?.disclosures;  
          this.htmlContent= response?.common?.trusteeData?.trusteesHtmlContent;     
        }
      );
    
  }

  onCheckboxClick(event: any, report: any, type: string): void {
    this.spinner.show();
    const payload = {
      type: report.type,
      periodId: this.trusteesReportForm.get('accountingPeriod')?.value,
      IsCheck: event.checked
    };

    this.store.dispatch(new ToggleCheckTrustee(payload)).subscribe(() => {
      // Fetch the latest updated reports
      this.getAllDislcosuresListBasedonType();
    this.commonService.onSucess(NotificationTextMessage.successMessage);  
    });
  }

  getTrusteesDataById(type): void{
    this.store.dispatch(new GetTrusteesDataByPeriodId(type, this.trusteesReportForm.get('accountingPeriod')?.value)).pipe().subscribe(
      (response: any) => {
        this.trusteeReportDetails = response?.reportSettings?.trusteeReportDetails;
        this.editReport(this.trusteeReportDetails.title, this.trusteeReportDetails.content, 'trustees');
      }
    );
  }

  editReport(title: any, content: any, type: string){
    const dialogRef = this.dialog.open(EditAuditReportPopupComponent,{
      disableClose: true  
    });

    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.type = type;
    dialogRef.componentInstance.content = content;
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        if(type == 'trustees'){
        this.trusteeReportDetails.content = result.content;  
         this.trusteeReportDetails.title = result.title;  
        } 
        this.saveReportDetails(type);
      }
    });
  }

  saveReportDetails(type: string): void{
    if(type == 'trustees'){
      const selectedPeriodId = this.trusteesReportForm.get('accountingPeriod')?.value;
      this.trusteeReportDetails.accountingPeriodId = selectedPeriodId;
      this.store.dispatch(new SaveTrusteeDisclosures(this.trusteeReportDetails)).pipe().subscribe(
        (response: any) => {
          this.commonService.onSucess(NotificationTextMessage.successMessage);
          this.getAllDislcosuresListBasedonType();
        }
      );
    } 
  }

  combineCheckedReportsContent(): void {
    const checkedReports = this.trusteeReports?.filter(report => report.isChecked);

    if (!checkedReports || checkedReports.length === 0) {
      this.trusteesReportForm.get('textbox1')?.setValue('');
      return;
    }

    const reportPromises = checkedReports.map((report) =>
      this.store.dispatch(new GetTrusteesDataById(report.type)).toPromise()
    );

    Promise.all(reportPromises)
      .then((responses: any[]) => {
        let combinedContent = '';

        responses.forEach((response, index) => {
          const details = response?.reportSettings?.trusteeReportDetails;
          if (details) {
            combinedContent += `
              <h3 style="margin-top: 16px; color: #333;">${details.title}</h3>
              <div style="margin-bottom: 16px;">${details.content || ''}</div>
            `;
          }
        });

        this.trusteesReportForm.get('textbox1')?.setValue(combinedContent);
      })
      .catch((err) => {
        console.error('Error fetching trustee report data:', err);
        this.trusteesReportForm.get('textbox1')?.setValue('');
      });
  }
  iscompanyRegistered:boolean;
   
    getContactDetails(): void{
      this.store.dispatch(new GetAllContactsBasedonType(2)).pipe().subscribe(
        (response: any) => {
       
          this.iscompanyRegistered=response?.reportSettings?.iscompanyRegistered;
          this.isAudicted=response?.reportSettings?.isAudited;
          this.charityType=response?.reportSettings?.charityType;
          if( this.iscompanyRegistered && this.charityType === 3){
            setTimeout(() => {
              this.getAllDislcosuresListBasedonType();
            }, 500);
         
          }
            
         
        }
      );
    }

    changePeriod(): void{
       if(this.isTrusteeReport){
        if(this.charityType === 3 && this.iscompanyRegistered){
            this.getAllDislcosuresListBasedonType();
        }else{
        this.editNotes();
        }        
       }else{
        this.editNotes();
       } 

       this.onAccountPeriodChange();
    }
    htmlContent:string;
     transformYourHtml() {
    return this.sanitizer.bypassSecurityTrustHtml(this.htmlContent);
  }

  setInvoiceDateLimits(): void {
    if (this.periodicDate?.length > 0) {
      const unlockedPeriod = this.periodicDate.find(
        (period: any) => !period.isLocked
      );

      if (unlockedPeriod) {
        this.minInvoiceDate = new Date(unlockedPeriod.fromDate);
      } else {
        this.minInvoiceDate = new Date(this.periodicDate[0].fromDate);
      }

      this.maxInvoiceDate = new Date(
        this.periodicDate[this.periodicDate.length - 1]?.toDate
      );
    }
  }
}
